import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import VehicleCard from "../../components/cards/VehicleCard/VehicleCard";
import vehiclesData from "../../data/vehiclesData";
import VehicleListCard from "../../components/cards/VehicleListCard/VehicleListCard";


import './VehiclesPage.css'
import AftersalesSupportSection from "../../components/sections/AftersalesSupportSection/AftersalesSupportSection";

export default function VehiclesPage() {
    return (
        <div className="vehiclesPage">
            <div className="vehiclesPageBanner text-center">
                <div className="page-banner-content">
                    <h3>
                        Explore
                    </h3>
                    <h1>
                        LandKing LineUp
                    </h1>
                </div>
            </div>

            <Container fluid>
                <div className="section-spacing">
                    <p class="brand-section-desc text-center mb-0">Built with Chinese engineering excellence and trusted by Saudi businesses</p>
                    <p class="brand-section-desc text-center mb-0">LANDKING Trucks deliver power, durability, and efficiency for every commercial need.</p>
                </div>
                {/* 
                <div className="vehicles-page__list">
                    {vehiclesData.map((vehicle) => (
                        <VehicleListCard key={vehicle.id} vehicle={vehicle} />
                    ))}
                </div> */}

                <Row className="gy-4">
                    {vehiclesData.map((vehicle) => (
                        <Col key={vehicle.id} md={12} lg={6}>
                            <VehicleListCard vehicle={vehicle} />
                        </Col>
                    ))}
                </Row>
            </Container>

            <div className="section-spacing-top">
                    <AftersalesSupportSection/>
            </div>
        </div>
    );
}